// client/src/utils/userRoles.js
// Small helper to centralize role checks on the client

// Mirrored bridge of server canonical persisted/domain user type values.
// Keep import path stable for existing web usage; parity is enforced by scripts/check-constant-parity.js.
export const USER_TYPE = Object.freeze({
  PLAYER: 'player',
  ADMIN: 'admin',
  OWNER: 'owner',
})

export const USER_TYPE_VALUES = Object.freeze([
  USER_TYPE.PLAYER,
  USER_TYPE.ADMIN,
  USER_TYPE.OWNER,
])

export const ADMIN_USER_TYPE_VALUES = Object.freeze([
  USER_TYPE.ADMIN,
  USER_TYPE.OWNER,
])

/**
 * Returns true if the given user object represents an admin-equivalent
 * (admin or owner). Mirrors backend isAdminUserType logic.
 * @param {{ user_type?: string } | null | undefined} user
 */
export function isAdmin(user) {
  return ADMIN_USER_TYPE_VALUES.includes(user?.user_type)
}

/**
 * Returns true if the given user object represents an owner.
 * Used for owner-only features and access control.
 * @param {{ user_type?: string } | null | undefined} user
 */
export function isOwner(user) {
  return user?.user_type === USER_TYPE.OWNER
}

const UserRoles = { isAdmin, isOwner }
export default UserRoles
